import { handleActions } from 'redux-actions';
import {
  getCurrentAnswer,
  getActiveDetail,
  saveAnswers,
  saveDocuments,
  removeAnswers,
  removeDocuments,
  setCollapseClient,
  setCurrentNotificationReview,
  setCurrentNotificationReviewId,
  saveAttachments,
  removeAttachments,
  goBackClientNotify,
  getAdvisors,
  setLastNotifyId,
  saveContactAnswers,
} from '../actions/notificationReviewActions';

const defaultState = {
  currentAnswer: null,
  activeDetail: null,
  answers: [],
  documents: [],
  isCollapse: false,
  currentNotificationReview: null,
  currentNotificationReviewId: '',
  attachments: [],
  isBackClientNotify: false,
  advisors: [],
  lastNotifyId: '',
  contactNotifyId: '',
};

export default handleActions(
  {
    [getCurrentAnswer](state, action) {
      return { ...state, currentAnswer: action.payload };
    },
    [getActiveDetail](state, action) {
      return { ...state, activeDetail: action.payload };
    },
    [saveAnswers](state, action) {
      return { ...state, answers: action.payload };
    },
    [saveDocuments](state, action) {
      return { ...state, documents: action.payload };
    },
    [saveAttachments](state, action) {
      return { ...state, attachments: action.payload };
    },
    [removeAnswers](state, action) {
      const { index } = action.payload;
      const answerSort = state.answers.sort((a, b) => new Date(b.created) - new Date(a.created));
      const newAnswers = answerSort.filter((item, i) => i !== index);
      return { ...state, answers: newAnswers };
    },
    [removeDocuments](state, action) {
      const { index } = action.payload;
      const fileSort = state.documents.sort((a, b) => new Date(b.created) - new Date(a.created));
      const newFiles = fileSort.filter((item, i) => i !== index);
      return { ...state, documents: newFiles };
    },
    [removeAttachments](state, action) {
      const { index } = action.payload;
      const newFiles = state.attachments.filter((item, i) => i !== index);
      return { ...state, attachments: newFiles };
    },
    [setCollapseClient](state, action) {
      return { ...state, isCollapse: action.payload };
    },
    [setCurrentNotificationReview](state, action) {
      return { ...state, currentNotificationReview: action.payload };
    },
    [setCurrentNotificationReviewId](state, action) {
      return { ...state, currentNotificationReviewId: action.payload };
    },
    [goBackClientNotify](state, action) {
      return { ...state, isBackClientNotify: action.payload };
    },
    [getAdvisors](state, action) {
      return { ...state, advisors: action.payload };
    },
    [setLastNotifyId](state, action) {
      return { ...state, lastNotifyId: action.payload };
    },
    [saveContactAnswers](state, action) {
      return { ...state, contactNotifyId: action.payload };
    },
  },
  defaultState
);
